import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect } from "react";
import PDFViewer from "./bot-reports/PDFViewer";
import styles from "../../styles/Components/bot/BotPerformanceReport.module.css";
import { FaAngleLeft } from "react-icons/fa";

function PdfReport({ backPath }) {
  const [searchParams] = useSearchParams();
  const pdfLink = searchParams.get("pdf");

  const navigate = useNavigate();

  useEffect(() => {
    if (!pdfLink) {
      navigate(backPath);
    }
  }, [pdfLink]);

  return (
    <div className={styles.container}>
      <div className={styles.backBtn} onClick={() => navigate(backPath)}>
        <FaAngleLeft /> Back
      </div>
      <PDFViewer url={pdfLink} />
    </div>
  );
}

export default PdfReport;
